import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Buttons/Button';
import { Check, X } from 'lucide-react';
import { STARTUP_RELATION_STATUS } from 'constants/startup';
import { Tag } from 'xland-ui';

function StartupRowButtons({ relation, literals, handleChangeStatus }) {
  return relation?.status === 'pending' ? (
    <div className='d-flex justify-content-end'>
      <Button className='btn-sm' text={literals.accept} icon={Check} onClick={e => handleChangeStatus(e, STARTUP_RELATION_STATUS.ACCEPTED)} />
      <Button className='btn-sm ms-2' text={literals.reject} icon={X} color='danger' onClick={e => handleChangeStatus(e, STARTUP_RELATION_STATUS.REJECTED)} />
    </div>
  ) : (
    <div className='company_keywords'>
      <Tag
        type='secondary'
        text={literals[relation?.type]}
        className='tag'
      />
      {
        relation?.shareholders?.length > 0 && (
          <Tag
            type='secondary'
            text={literals.shareholder}
            className='tag'
          />
        )
      }
    </div>
  );
}

StartupRowButtons.propTypes = {
  relation: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  handleChangeStatus: PropTypes.func.isRequired,
};

export default StartupRowButtons;
